import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const exportPaymentsToExcel = (sheetName, payments) => {
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(payments || []);

  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(dataBlob, `${sheetName}.xlsx`);
};
